import importerStore from '@shared/importer/importer-store';
import { TrainingService } from '@modules/training/training-service';
import trainingImporterFields from '@modules/training/training-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  TrainingService.import,
  trainingImporterFields,
  i18n('entities.training.importer.fileName'),
  i18n('entities.training.importer.hint'),
);
